var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-webon-table",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onEditClicked.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-eye"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }